import React, { Suspense, lazy, useCallback, useEffect, useLayoutEffect, useReducer, useRef, useState } from 'react';
import { IAppLayout } from '../../components/EsSidebar/EsSideBarAndHeader';
import { useResizableSidebar } from '../../components/EsSidebar/useResizableSidebar';
import { Outlet, useLocation, useMatch, useSearchParams } from 'react-router-dom';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AnimatedBox } from '../../components/AnimatedComponents/AnimatedView';
import { useThemeContext } from '../../hook/useThemeManager';
import { EsScrollToTop } from '../../Router/EsScrollToTop';
import { batch, useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/authentication/action';
import { AuthModal } from '../../components/AuthModal/AuthModal';
import { ReferralUrlCapture } from '../../components/ReferralCapture/ReferralUrlCapture';
import { DashboardWorkspaceRedirect } from '../../components/DashboardWorkspaceRedirect';
import InterstitialAdBanner from '../../components/InterstitialAdBanner';
import {
    autoPublishAndSubmitSelector,
    campaignSubmissionModalOpenerSelector,
    existingPaySubmissionIdSelector,
    contestPhaseDateSelector,
    creatorModalSelector,
    creatorModalVisibleSelector,
    currentFiltersSelector,
    currentProjectInCreationSelector,
    currentSubmissionSelector,
    filterSubCategorySelector,
    gettingNotificationsSelector,
    inAppNotificationSelector,
    initialContestEditingDataSelector,
    isDrawerOpen,
    isProjectProcessingSelector,
    isSearchBoxOpenSelector,
    isUserJurySelector,
    isUsersFirstProjectSelector,
    isVotingEnabledSelector,
    likeActionInProgressSelector,
    mediaControlConfigurationSelector,
    mediaForgeMessageSelector,
    mediaForgeReportSelector,
    nebulaSuggestionSelector,
    playerPlaylistTypeSelector,
    playerQuerySelector,
    projectQuerySeletcor,
    reportModalSelector,
    searchResultSelector,
    searchingStatusSelector,
    selectedCampaignForSubmissionSelector,
    selectedSuggestionSelector,
    showAppGuideSelector,
    showFirstProjectCongratulatorySelector,
    showIntroductionFlowSelector,
    showProjectCreatorGuideSelector,
    showProjectCreatorSuggstionBoxSelector,
    suggestedThspiansSelector,
    toggleAccountModalSelector,
    toggleInterestModalSelector,
    toggleNotificationSelector,
    toggleCookiesDrawerSelector,
    toggleStateSelector,
    userFollowingSelector,
    userLikesSelector,
    userNotificationCountSelector,
    userNotificationSelector,
    votingBoothItemsSelector,
    nebulaMuteSelector,
    shareModalStatusSelector,
    sharePayloadSelector,
    systemLoadingSelector,
    isProjectProcessingDoneSelector,
    showProjectSubmissionPromptSelector,
    isUserCastingDirectorSelector,
    liveCampaignsSelector,
    focusCampiagnSelector,
    uploadPayloadSelector,
    recommendationSelector,
    currentSystemForm,
    toggleAccountSubscriptionModalSelector,
    playlistPaginationSelector,
    authModalSelector,
    formsSelector,
    userLocationSelector,
} from '../../selectors/selectors';
import { E_FEATURE_FLAGS, useFeatureFlag } from '../../hook/useFeatureFlag';
import { IUgcSearchLocation } from '../../redux/discovery/types';
import { readUgcRecentSearches, rememberUgcSearch } from '../../components/EsSidebar/EsSearch/ugcRecentSearch';
import {
    clearFilter,
    getSystemForms,
    setFilter,
    setFilterSubCategory,
    setShareModalStatus,
    setShowProjectCreatorGuide,
    setShowSearchBox,
    setSystemForm,
    setUsersFirstProjectSuggestionBox,
    toggleAccountModal,
    toggleInterestModal,
    toggleCookiesModal,
    toggleCreatorModal,
    toggleDrawer,
    toggleFiler,
    toggleNotification,
    toggleSubscriptionModal,
    toggleToast,
} from '../../redux/appConfigurator/action';
import { FilterItem, FilterTypes, IFilter, filters, mainCategorySelector } from '../../data/filters/discovery.data';
import _, { isArray, isEmpty } from 'lodash';
import {
    canLoadMoreFeedSelector,
    currentSelectedVideoComments,
    currentVideoDetailsSelector,
    currentVideoSelector,
    feedSelector,
    followingSelector,
    horizontalPlayerSelector,
    interstitialAdsSelector,
    isSelectedFilterEmptySelector,
    playlistSelector,
    searchSuggestionsSelector,
    selectedActSelector,
    selectedProjectComents,
    toastSelector,
    userProfileSelector,
    verticalPlayerSelector,
} from './selectors';
import { getMyActivities, getSearchSuggestions, hideMyActivity } from '../../redux/activity/actions';
import {
    bytesToMB,
    catchAsync,
    getJWtDetails,
    parseFileFormats,
    replacePageValue,
    showToastMessage,
    useDispatchPromise,
} from '../../utils/AppUtils';
import { filter, searchDiscovery, setViewAll } from '../../redux/discovery/actions';
import { navigate } from '../../redux/navigator/action';
import { ROUTES } from '../../types/global/routes.types';
import { CreatorType } from '../../redux/appConfigurator/types';
import { IContentCreator } from '../../components/ContentCreator/ContentCreator';
import Dropzone, { FileRejection } from 'react-dropzone';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { strings } from '../../constants';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { IVerticalVideoPlayer } from '../../components/VideoPlayer/VerticalVideoPlayer';
import { IVideoPlayerModal } from '../../components/VideoPlayer/HorizontalVideoPlayer';
import {
    createProject,
    deleteComment,
    deleteLike,
    getFeed,
    getPlaylist,
    getProject,
    getProjectDetails,
    getProjects,
    leaveComment,
    likeComment,
    likeProject,
    mediaForgeWorker,
    publishProject,
    selectNebulaSuggestion,
    setAutoPlay,
    setPlayerQuery,
    setmedia,
    updateComment,
} from '../../redux/project/actions';
import {
    IContest,
    IProject,
    ISubmission,
    ITopUser,
    IUserSummary,
    Likes,
    TComment,
    UserSummary,
    CreatorLocation,
    IAudition,
    IEvent,
    PrizeD,
} from '../../types/global/helper';
import { INebulaSuggestion, MediaType } from '../../redux/project/types';
import { CellType } from '../../components/EsSidebar/EsSearch/SearchCell';
import { ActivityResponse, SearchSuggestion } from '../../redux/activity/types';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { openSubmissionPaymentCheckout } from '../../utils/openSubmissionPaymentCheckout';
import { IAutoSuggestionSearchCell } from '../../types/global/generic.types';
import { connect } from '../../redux/live/action';
import { initialState, reducer } from './applayout.reducer';
import { initialState as contestInitialState, reducer as contestReducer } from './contestCreator.reducer';
import {
    initialState as offsiteCampaignInitialState,
    reducer as offsiteCampaignReducer,
} from './offsiteCampaignCreator.reducer';
import { CustomToast } from '../../components/Toast/CustomToast';
import { Id, toast } from 'react-toastify';
import { Loading } from '../../components/Loading/Loading';
import { UploadWaitModal } from '../../components/Loading/UploadWaitModal';
import { ICampaignSubmitterInterface } from '../../components/CampaignSubmitter/CampaignSubmitter';
import {
    createContest,
    deleteAwardCategory,
    getMySubmissions,
    initaiet2FAForVote,
    resetVoteFlow,
    setAutoPublishAndSubmit,
    setCampaignForSubmission,
    setCategoryForSubmission,
    setContestForEdit,
    setFocusCampaign,
    setSubmissionModalState,
    setSubmissionPrompt,
    setVoting2Fa,
    setVotingFlow,
    submitProject,
    completeSubmissionPayment,
    updateContest,
} from '../../redux/contest/actions';
import { ILike } from '../../redux/account/types';
import { IActSummary, IAdvertisement } from '../../types/global/media.types';
import { IReportModal } from '../../components/Report/ReportModal';
import { openReportModal, sendReport } from '../../redux/report/actions';
import { ReportPayload } from '../../redux/report/types';
import { ICreateView } from '../../redux/view/types';
import { createView } from '../../redux/view/action';
import { CustomModalProps } from '../../components/InAppNotification/InAppNotification';
import { clearInAppNotification } from '../../redux/in-app-notification/actions';
import { playlistLoadingContentSelector } from '../EsWatchVideo/selectors';
import {
    deleteNotification,
    getMyNotifications,
    readNotification,
    updateNotification,
} from '../../redux/notifications/action';
import { WebNotification } from '../../redux/account/accountDetailsResponse.type';
import { MediaReportConsole } from '../../components/InAppNotification/MediaReportConsole';
import {
    getGlobalConfig,
    getUserConfig,
    hydrateOperatingLocationFromBrowser,
    updateUserConfig,
} from '../../redux/configuration/action';
import { useShowFilter } from '../../hook/useHideFilter';
import { en_config } from '../../config';
import { IIntroductionModal } from '../../components/IntroductionModal/IntroductionModal';
import { introductionSteps, projectCreationSeps } from '../../components/IntroductionModal/introductionSteps.data';
import { updateUserProfile } from '../../redux/user/actions';
import { getSuggestedThspians, followAThspian, getMyFollowing, unfollowThspian } from '../../redux/audience/action';
import { ITutorialProps } from '../../components/Tutorial/Tutorial';
import { tutorialSteps } from '../../components/EsSettings/settings.data';

import { MIXPANEL_EVENT, MixPanel } from '../../analytics/Mixpanel';
import { withNetworkStatus } from '../../components/NetworkStatus/NetworkStatus';
import { parseContestPayload, parseProjecPaload } from './helper';
import { setPendingPostAutomationIntent } from '../../constants/postAutomationIntent';
import { IProps } from '../../components/CookieFooter/CookieFooter';
import { IInfoBox } from '../../components/InfoBox/InfoBox';
import { IModalProps } from '../../components/CookiePreferenceDrawer/CookiePreference';
import { IVotingBooth } from '../../components/VotingBooth/VotingBooth';
import { setMute } from '../../redux/player/action';
import { checkAndNuke } from '../../redux/cache/action';
import { IShareModalProps } from '../../components/ShareModal/ShareModal';
import { ProgressBar } from '../../components/ProgressBar/ProgressBar';
import { IProjectSubmissionBox } from '../../components/InfoBox/ProjectSubmissionBox';
import { getAd, hideAdBanner, trackAd } from '../../redux/adverts/action';
import { pauseUpload, restartUploadAfterReload, resumeUpload, terminateUplaod } from '../../redux/upload/action';
import { titleFromUploadedFileName, validateFile } from '../../utils/mediaHelper';
import { categoryRequiresSubmissionPayment, findContestSubmissionCategory } from '../../utils/contestSubmissionMode';
// import { IFooterProps } from '../../components/Footer/EsFooter';
import { EsFiltersMobile } from '../../components/EsSidebar/EsFilters/EsFiltersMobile';
import { EsFiltersDesktop } from '../../components/EsSidebar/EsFilters/EsFiltersDesktop';
import { IRoleDialogueProps } from '../../components/RoleDialogue/RoleDialogue';
import { roleSelector } from '../Audition/selector';
import { IRecommendationDialogueProps } from '../../components/RecommendationDialogue/RecommendationDialogue';
import { GenericFormFillerProps } from '../../components/Feed/GenericFormFiller';
import { IAccountSubscriptionModal } from '../AccountSettings';
import { useAsyncStorage } from '../../hook/useAsyncStorage';
import { refreshToken as refreshTokenAction } from '../../redux/refreshToken/action';
import type { RootState } from '../../redux/root-reducer';

import { createOffsiteCampaign } from '../../redux/buzzbridge/actions';
import { getPublishableKey, getPaymentRail } from '../../redux/payment/action';
import { defaultCheckoutProvider, resolvePaymentRail } from '../../utils/paymentRail';
import { getRouteAlias } from '../../redux/routeAlias/action';
import { IFloatingMessageButtonProps } from '../../components/FloatingChat/FloatingMessageButton';

const AccountSubscriptionModal = lazy<React.FC<IAccountSubscriptionModal>>(() =>
    //@ts-ignore
    import('../../pages/AccountSettings').then(module => {
        return { default: module.AccountSubscriptionModal };
    }),
);

const CheckoutModal = lazy<React.FC>(() =>
    //@ts-ignore
    import('../../components/Checkout/CheckoutModal').then(module => {
        return { default: module.CheckoutModal };
    }),
);

const GenericFormFiller = lazy<React.FC<GenericFormFillerProps>>(() =>
    //@ts-ignore
    import('../../components/Feed/GenericFormFiller').then(module => {
        return { default: module.GenericFormFiller };
    }),
);

const RoleDialogue = lazy<React.FC<IRoleDialogueProps>>(() =>
    //@ts-ignore
    import('../../components/RoleDialogue/RoleDialogue').then(module => {
        return { default: module.RoleDialogue };
    }),
);

const RecommendationDialogue = lazy<React.FC<IRecommendationDialogueProps>>(() =>
    //@ts-ignore
    import('../../components/RecommendationDialogue/RecommendationDialogue').then(module => {
        return { default: module.RecommendationDialogue };
    }),
);

// const EsFooter = lazy<React.FC<IFooterProps>>(() =>
//     //@ts-ignore
//     import('../../components/Footer/EsFooter').then(module => {
//         return { default: module.EsFooter };
//     }),
// );

const InAppNotification = lazy<React.FC<CustomModalProps>>(() =>
    //@ts-ignore
    import('../../components/InAppNotification/InAppNotification').then(module => {
        return { default: module.InAppNotification };
    }),
);
const IntroductionModal = lazy<React.FC<IIntroductionModal>>(() =>
    //@ts-ignore
    import('../../components/IntroductionModal/IntroductionModal').then(module => {
        return { default: module.IntroductionModal };
    }),
);
const InfoBox = lazy<React.FC<IInfoBox>>(() =>
    //@ts-ignore
    import('../../components/InfoBox/InfoBox').then(module => {
        return { default: module.InfoBox };
    }),
);

const FloatingMessageButton = lazy<React.FC<IFloatingMessageButtonProps>>(() =>
    //@ts-ignore
    import('../../components/FloatingChat/FloatingMessageButton').then(module => {
        return { default: module.FloatingMessageButton };
    }),
);
const ShareModal = lazy<React.FC<IShareModalProps>>(() =>
    //@ts-ignore
    import('../../components/ShareModal/ShareModal').then(module => {
        return { default: module.ShareModal };
    }),
);
const VotingBooth = lazy<React.FC<IVotingBooth>>(() =>
    //@ts-ignore
    import('../../components/VotingBooth/VotingBooth').then(module => {
        return { default: module.VotingBooth };
    }),
);
const VerticalVideoPlayer = lazy<React.FC<IVerticalVideoPlayer>>(() =>
    //@ts-ignore
    import('../../components/VideoPlayer/VerticalVideoPlayer').then(module => {
        return { default: module.VerticalVideoPlayer };
    }),
);
const ReportModal = lazy<React.FC<IReportModal>>(() =>
    //@ts-ignore
    import('../../components/Report/ReportModal').then(module => {
        return { default: module.ReportModal };
    }),
);

//type CombinedProps = IMediaConsolRef & CustomModalProps;

// const MediaReportConsole = lazy<React.FC<CombinedProps>>(() =>
//     //@ts-ignore
//     import('../../components/InAppNotification/MediaReportConsole').then(module => {
//         return { default: module.MediaReportConsole };
//     }),
// );
const ProjectSubmissionBox = lazy<React.FC<IProjectSubmissionBox>>(() =>
    //@ts-ignore
    import('../../components/InfoBox/ProjectSubmissionBox').then(module => {
        return { default: module.ProjectSubmissionBox };
    }),
);
const CampaignSubmitter = lazy<React.FC<ICampaignSubmitterInterface>>(() =>
    //@ts-ignore
    import('../../components/CampaignSubmitter/CampaignSubmitter').then(module => {
        return { default: module.CampaignSubmitter };
    }),
);
const HorizontalVideoPlayerModal = lazy<React.FC<IVideoPlayerModal>>(() =>
    //@ts-ignore
    import('../../components/VideoPlayer/HorizontalVideoPlayer').then(module => {
        return { default: module.HorizontalVideoPlayerModal };
    }),
);
const ContentCreator = lazy<React.FC<IContentCreator>>(() =>
    //@ts-ignore
    import('../../components/ContentCreator/ContentCreator').then(module => {
        return { default: module.ContentCreator };
    }),
);
const EsSideBarAndHeader = lazy<React.FC<IAppLayout>>(() =>
    //@ts-ignore
    import('../../components/EsSidebar/EsSideBarAndHeader').then(module => {
        return { default: module.EsSideBarAndHeader };
    }),
);
const Tutorial = lazy<React.FC<ITutorialProps>>(() =>
    //@ts-ignore
    import('../../components/Tutorial/Tutorial').then(module => {
        return { default: module.Tutorial };
    }),
);
const CookiePreferenceDrawer = lazy<React.FC<IModalProps>>(() =>
    //@ts-ignore
    import('../../components/CookiePreferenceDrawer/CookiePreference').then(module => {
        return { default: module.CookiePreferenceDrawer };
    }),
);
const CookieFooter = lazy<React.FC<IProps>>(() =>
    //@ts-ignore
    import('../../components/CookieFooter/CookieFooter').then(module => {
        return { default: module.CookieFooter };
    }),
);
const PeopleModal = lazy<React.FC<{ open: boolean; onClose?: () => void; userType?: string[] }>>(() =>
    //@ts-ignore
    import('../../components/PeopleModal/PeopleModal').then(module => {
        return { default: module.PeopleModal };
    }),
);
const InterestModal = lazy<React.FC<{ open: boolean; onClose?: () => void }>>(() =>
    //@ts-ignore
    import('../../components/InterestModal/InterestModal').then(module => {
        return { default: module.InterestModal };
    }),
);

/**
 *
 * @returns Outlet.
 *  Wraps around dashboard to render children component
 */

const useStyles = makeStyles(theme => ({
    appLayout: {
        /**
         * Flex (not grid): many modal/toast siblings are `position: fixed` but still
         * occupy CSS grid cells. With `gridTemplateRows: 1fr auto`, the first sibling
         * ate the `1fr` row and pushed EsSideBarAndHeader (Outlet) down the viewport.
         */
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        /** `100vw` includes scrollbar gutter and causes horizontal clip on narrow viewports */
        width: '100%',
        maxWidth: 'min(100%, 100dvw)',
        minWidth: 0,
        overflowX: 'hidden',
    },
    content: {
        overflowY: 'auto', // Enable vertical scrolling for the content,
        overflowX: 'hidden',
        minWidth: 0,
    },
    mainShell: {
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    dropBox: {
        border: '2px dashed orange', // Change border color to white
        borderRadius: 10,
        padding: 4,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '50vh',
        width: '50vw',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'border-color 0.3s ease-in-out',
        marginLeft: '25%',
        marginTop: '15%',
        '&:hover': {
            borderColor: 'grey',
        },
    },
}));

const AppLayout = () => {
    const classes = useStyles();
    const { isSignedIn, user } = getJWtDetails();
    const sidebar = useResizableSidebar();
    const [searchTerm, setSearchTerm] = useState('');
    const [ugcOnly] = useFeatureFlag([E_FEATURE_FLAGS.UGC_ONLY]);
    const currentLocation = useSelector(userLocationSelector);
    const [ugcSearchLocation, setUgcSearchLocation] = useState<IUgcSearchLocation | null>(null);
    const [recentSearches, setRecentSearches] = useState<string[]>(() => readUgcRecentSearches());
    const ugcOnlyRef = useRef(ugcOnly);
    const ugcSearchLocationRef = useRef(ugcSearchLocation);
    ugcOnlyRef.current = ugcOnly;
    ugcSearchLocationRef.current = ugcSearchLocation;
    const backendPlace =
        currentLocation?.city && currentLocation.city !== 'unknown'
            ? currentLocation.city
            : currentLocation?.country && currentLocation.country !== 'unknown'
            ? currentLocation.country
            : '';
    const [showPeopleModal, setShowPeopleModal] = useState(false);
    const [selectedInterstitialAd, setSelectedInterstitialAd] = useState<IAdvertisement | null>(null);
    const [showInterstitialAd, setShowInterstitialAd] = useState(false);

    const storedRefreshToken = useSelector((state: RootState) => state.authentication.refreshToken);
    const refreshingToken = useSelector((state: RootState) => state.tokenRefresh.refreshingToken);

    const drawerOpen = useSelector(isDrawerOpen);
    const searchBoxOpen = useSelector(isSearchBoxOpenSelector);
    const drawerStatus = useSelector(toggleStateSelector);
    const subscriptionModalOpen = useSelector(toggleAccountSubscriptionModalSelector);
    const currentFilters = useSelector(currentFiltersSelector);
    const selectedFilterSubCategory = useSelector(filterSubCategorySelector);
    const selectedRole = useSelector(roleSelector);
    const recommendation = useSelector(recommendationSelector);
    const shoudlOpenSubmissionModal = useSelector(campaignSubmissionModalOpenerSelector);
    const existingPaySubmissionId = useSelector(existingPaySubmissionIdSelector);
    const autoPublishAndSubmit = useSelector(autoPublishAndSubmitSelector);
    const selectedContestForSubmission = useSelector(selectedCampaignForSubmissionSelector);
    const showIntroductionFlow = useSelector(showIntroductionFlowSelector);
    const showAppGuide = useSelector(showAppGuideSelector);
    const { fetchingSuggestedThspians, suggestedThspians } = useSelector(suggestedThspiansSelector);
    const { showVotingBooth, submissions, showVoting2Fa, voteOtpSendingInProgress, startingIndex } =
        useSelector(votingBoothItemsSelector);
    const userFollowing = useSelector(userFollowingSelector);
    const initialContestValues = useSelector(initialContestEditingDataSelector);
    const showProjectSubmissionPrompt = useSelector(showProjectSubmissionPromptSelector);
    const gettingPlaylist = useSelector(playlistLoadingContentSelector);
    const isUserJuryEntitled = useSelector(isUserJurySelector);
    const isUserCastingDirectorEntitled = useSelector(isUserCastingDirectorSelector);
    const userNotificationCount = useSelector(userNotificationCountSelector);
    const notificationStatus = useSelector(toggleNotificationSelector);
    const accountModalStatus = useSelector(toggleAccountModalSelector);
    const interestModalOpen = useSelector(toggleInterestModalSelector);
    const systemMute = useSelector(nebulaMuteSelector);
    const selectedSystemForm = useSelector(currentSystemForm);

    const cookiesDrawerOpen = useSelector(toggleCookiesDrawerSelector);
    // const projectActivelyProcessing = useSelector(isProjectActivelyProcessing);
    const projectActivelyInCreation = useSelector(isProjectProcessingSelector);
    const projectQuery = useSelector(projectQuerySeletcor);
    const playlistPagination = useSelector(playlistPaginationSelector);
    const reportModalOpen = useSelector(reportModalSelector);
    const userNotifications = useSelector(userNotificationSelector);

    const searching = useSelector(searchingStatusSelector);
    const searchResults = useSelector(searchResultSelector);
    const gettingNotifications = useSelector(gettingNotificationsSelector);
    const disableFilterButton = useSelector(isSelectedFilterEmptySelector);
    /** The below is used to set the search box suggestions and recent search of the ucrrent user */
    const { myActivity, suggestions } = useSelector(searchSuggestionsSelector);
    const creatorSelector = useSelector(creatorModalSelector);
    const contentCreatorModalVisible = useSelector(creatorModalVisibleSelector);
    const globalMediaControl = useSelector(mediaControlConfigurationSelector);
    const systemLoading = useSelector(systemLoadingSelector);

    /** Campign Upload */
    const liveCampaigns = useSelector(liveCampaignsSelector);
    const focusCampaign = useSelector(focusCampiagnSelector);

    const systemForms = useSelector(formsSelector);

    /**Suggestion Box */
    const showProjectSuggestionBox = useSelector(showFirstProjectCongratulatorySelector);
    const shoowProjectCreatorGuide = useSelector(showProjectCreatorGuideSelector);
    const shouldShowSuggestionBox = useSelector(isUsersFirstProjectSelector);
    const currentProjectInCreation = useSelector(currentProjectInCreationSelector) as IProject;
    const userAlreadyCreatedProject = useSelector(showProjectCreatorSuggstionBoxSelector);
    /**
     * The below monitors MediaForge Process
     */
    /** Gets when process report should start */
    const isProjectProcessing = useSelector(isProjectProcessingSelector);
    const currentUploadPayload = useSelector(uploadPayloadSelector);
    const isProjectProcessingDone = useSelector(isProjectProcessingDoneSelector);
    const { progress, uploadMessage, isPaused } = useSelector(mediaForgeMessageSelector);
    const shouldAvoidLoadingPlaylist = useSelector(playerPlaylistTypeSelector);
    const nebulaSuggestion = useSelector(nebulaSuggestionSelector);
    const selectedNebulaSuggestion = useSelector(selectedSuggestionSelector);
    const mediaForge = useSelector(mediaForgeReportSelector);
    /**
     * Show wait after create/upload starts from Submit — not when merely opening the creator.
     * Drive from autoPublish (armed on create) and/or an in-flight mediaForge while Submit is open.
     */
    const mediaForgeUploading =
        mediaForge?.status === 'initiated' ||
        mediaForge?.status === 'awaiting processing' ||
        mediaForge?.status === 'upload complete';
    const showContestUploadWait =
        !contentCreatorModalVisible &&
        (Boolean(autoPublishAndSubmit) || (Boolean(shoudlOpenSubmissionModal) && mediaForgeUploading));
    const showAuthModal = useSelector(authModalSelector);
    const interstitialAds = useSelector(interstitialAdsSelector);

    /**End of Media Forge Process Monitor */
    const { pathname, state: locationState } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const paySubmissionHandled = useRef(false);
    /** Set when Submit→upload opens creator; autoPublish only flips on real create submit. */
    const pendingContestAutoSubmitRef = useRef(false);
    /** Survives stale React closures when Dialog fires onClose after create submit. */
    const contestUploadInFlightRef = useRef(false);
    const currentVideo = useSelector(currentVideoSelector);
    const currentVideoDetails = useSelector(currentVideoDetailsSelector);
    const currentPlayListSelection = useSelector(playlistSelector);
    const currentFeedSelector = useSelector(feedSelector);
    const { page, canLoadMore, initialProjectId } = useSelector(canLoadMoreFeedSelector);
    const currentVideoComments = useSelector(currentSelectedVideoComments);
    const isVotingEnabled = useSelector(isVotingEnabledSelector);
    const inAppNotification = useSelector(inAppNotificationSelector);
    const votingStartDate = useSelector(contestPhaseDateSelector);
    const currentSubmission = useSelector(currentSubmissionSelector);
    const followingInProgress = useSelector(followingSelector);
    const likingInProgress = useSelector(likeActionInProgressSelector);
    const userProfile = useSelector(userProfileSelector);
    const { isSinglePreview } = useSelector(playerQuerySelector);
    const isShareStatusActive = useSelector(shareModalStatusSelector);
    const { title, url } = useSelector(sharePayloadSelector) || {};
    const dispatch = useDispatch();

    // Silently refresh the token on any page (including public ones like discovery).
    // ProtectedRoute handles the "hold or redirect" UI — this ensures the refresh
    // is always triggered regardless of whether the current route is protected.
    useEffect(() => {
        if (!isSignedIn && storedRefreshToken && !refreshingToken) {
            dispatch(refreshTokenAction({}));
        }
    }, [isSignedIn, storedRefreshToken, refreshingToken, dispatch]);

    useEffect(() => {
        if (!autoPublishAndSubmit) {
            contestUploadInFlightRef.current = false;
        }
    }, [autoPublishAndSubmit]);

    const dispatchPromise = useDispatchPromise();
    const { themeStyle, device } = useThemeContext();
    const muiTheme = useTheme();
    /** Matches `EsSideBarAndHeader` closed drawer rail (`closedMixin` at `sm+`). */
    const isMuiSmUp = useMediaQuery(muiTheme.breakpoints.up('sm'));
    const collapsedNavRail = `calc(${muiTheme.spacing(8)} + 1px)`;
    const mainContentMarginLeft = device.isDesktop ? `${sidebar.width}px` : isMuiSmUp ? collapsedNavRail : 0;
    const mainContentWidthExpr = device.isDesktop
        ? `calc(100vw - ${sidebar.width}px)`
        : isMuiSmUp
        ? `calc(100vw - ${collapsedNavRail})`
        : '100%';
    /** On xs, `100%` can exceed the device when the shell is wider than the viewport. */
    const mainContentMaxWidthExpr = device.isDesktop || isMuiSmUp ? mainContentWidthExpr : 'min(100%, 100dvw)';
    const [state, formDispatch] = useReducer(reducer, initialState);
    const [contestState, formContestDispatch] = useReducer(contestReducer, contestInitialState);
    const [offsiteCampaignState, formOffsiteCampaignDispatch] = useReducer(
        offsiteCampaignReducer,
        offsiteCampaignInitialState,
    );
    const [showInfoox, setShowInfoBox] = useAsyncStorage('showInfoBox', true);

    const playerOpen = useSelector(horizontalPlayerSelector);
    const actPlayerOpen = useSelector(verticalPlayerSelector);
    const selectedAct = useSelector(selectedActSelector);
    const userLikes = useSelector(userLikesSelector);
    const selectedProjectComments = useSelector(selectedProjectComents);
    const { message, open } = useSelector(toastSelector);
    const { showFilter } = useShowFilter();
    const toastId = useRef<Id>();
    const deviceUploadLimit = device.isMobile
        ? (globalMediaControl.mobile_size_limit as number)
        : (globalMediaControl.file_size_limit as number);
    const imageSizeLimit = globalMediaControl?.image_size_limit ?? en_config.MEDIA_CONFIG.image_size_limit;

    // const { marginLeft, viewWidth } = useSpring({
    //     marginLeft: drawerOpen ? 160 : 0,
    //     viewWidth: drawerOpen ? '90vw' : '100vw',
    //     config: {
    //         duration: 200,
    //         easing: easings.linear,
    //     },
    // });

    const handleDrawerToggle = () => {
        dispatch(setShowSearchBox('off'));
        dispatch(
            toggleFiler({
                filterStatus: 'off',
            }),
        );
        dispatch(toggleDrawer({ status: drawerStatus === 'open' ? 'closed' : 'open' }));
    };

    const updateCreateProjectFields = useCallback((field: string, value: any, mode: CreatorType) => {
        if (mode === 'project') {
            formDispatch({
                type: 'FIELD',
                field,
                value,
            });
        } else if (mode === 'offsite_campaign') {
            formOffsiteCampaignDispatch({
                type: 'FIELD',
                field,
                value,
            });
        } else {
            // Handles Create Camapign Upload
            formContestDispatch({
                type: 'FIELD',
                field,
                value,
            });
        }
    }, []);
    const onDrop = useCallback(
        async (acceptedFiles: File[], fileRejections: FileRejection[]) => {
            if (!isSignedIn) {
                showToastMessage('Login to create a new project', 'error', 5000);
                return;
            }

            // Check for file rejections first (e.g., file too large, wrong type, etc.)
            if (fileRejections && fileRejections.length > 0) {
                const rejection = fileRejections[0];
                const errors = rejection.errors;

                // Check the rejection reason
                if (errors.some(error => error.code === 'file-too-large')) {
                    // File exceeds maxSize
                    showToastMessage(
                        `File rejected. Max file size must be below ${bytesToMB(deviceUploadLimit)} MB`,
                        'error',
                        5000,
                    );
                } else if (errors.some(error => error.code === 'file-invalid-type')) {
                    showToastMessage('The following formats are supported .mov, .mp4', 'error', 5000);
                } else if (errors.some(error => error.code === 'too-many-files')) {
                    showToastMessage('Maximum of 1 file only', 'error', 5000);
                } else {
                    // Generic rejection message
                    showToastMessage(
                        `File rejected. Max file size must be below ${bytesToMB(deviceUploadLimit)} MB`,
                        'error',
                        5000,
                    );
                }
                return;
            }

            // If no rejections, validate the accepted file
            if (!acceptedFiles || acceptedFiles.length === 0) {
                return;
            }

            // Only validate video files
            const file = acceptedFiles[0];
            if (!file.type.startsWith('video/')) {
                showToastMessage('Only video files are supported', 'error', 5000);
                return;
            }

            const isValid = await validateFile(file, imageSizeLimit, deviceUploadLimit);

            if (!isValid.valid) {
                showToastMessage(isValid.error!, 'error', 5000);
                return;
            }
            if (isSignedIn && isEmpty(fileRejections)) {
                const file = acceptedFiles[0];
                const isVideoFile = file.type.startsWith('video');

                if (isVideoFile) {
                    const videoElement = document.createElement('video');
                    videoElement.preload = 'metadata';
                    dispatch(toggleCreatorModal({ creatorType: 'project' }));
                    videoElement.src = URL.createObjectURL(file);
                    videoElement.addEventListener('loadedmetadata', () => {
                        const videoMetadata = {
                            duration: videoElement.duration,
                            width: videoElement.videoWidth,
                            height: videoElement.videoHeight,
                            type: file.type,
                        };
                        updateCreateProjectFields('metadata', videoMetadata, 'project');
                        /** Sets if a video is played in horizontal or vertical format. Please check API */
                        updateCreateProjectFields(
                            'project_format',
                            videoMetadata.height < videoMetadata.width ? 'video' : 'act',
                            'project',
                        );
                    });

                    updateCreateProjectFields('project_file', acceptedFiles[0], 'project');
                    const fromFile = titleFromUploadedFileName(acceptedFiles[0].name);
                    if (fromFile) {
                        updateCreateProjectFields('title', fromFile, 'project');
                    }
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [updateCreateProjectFields],
    );

    // Sets the Main Category
    const handFilterToggle = (filter: FilterItem) => {
        MixPanel.track(MIXPANEL_EVENT.MAIN_CATEGORY_CLICK, {
            buttonAction: 'SELECT_MAIN_CATEGORY',
            categoryName: filter.value as FilterTypes,
        });
        dispatch(setShowSearchBox('off'));
        dispatch(
            setFilter({
                category: filter.value as FilterTypes,
                categoryPayload: filters[filter.value as keyof IFilter],
            }),
        );
    };

    // Sets the Sub Category
    const handleFilterSubCategorySelection = (filter: FilterItem, categoryId: number) => {
        MixPanel.track(MIXPANEL_EVENT.SUB_CATEGORY_CLICK, {
            buttonAction: 'SELECT_SUB_CATEGORY',
            buttonName: 'SELECT_SUB_CATEGORY',
            subCategoryId: categoryId,
            subCategoryValue: filter.value,
            subCategoryName: filter.displayName,
            subCategoryField: filter.field,
        });
        dispatch(setShowSearchBox('off'));
        dispatch(
            setFilterSubCategory({
                id: categoryId,
                value: filter.value,
                displayName: filter.displayName,
                field: filter.field,
            }),
        );
    };

    const handleLogout = () => {
        MixPanel.track(MIXPANEL_EVENT.LOGOUT, {
            buttonAction: 'LOGOUT',
            buttonName: 'LOGOUT',
        });
        dispatch(logout(undefined));
    };

    const handleClearFilters = () => {
        MixPanel.track(MIXPANEL_EVENT.CLEAR_FILTER_CLICK, {
            buttonAction: 'CLEAR_FILTER',
            buttonName: 'CLEAR FILTER',
        });
        dispatch(clearFilter());
    };

    useLayoutEffect(() => {
        if (_.isEmpty(currentFilters)) {
            /** set the initial default */
            handFilterToggle(mainCategorySelector[0].data.list[2]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleGetConfig = () => {
        dispatch(hydrateOperatingLocationFromBrowser());
        dispatch(checkAndNuke());
        dispatch(getGlobalConfig());
        if (isSignedIn) dispatch(getUserConfig());
        // Resolve pub key from payment rail (NG → paystack). Do not hardcode stripe —
        // a single Redux publishableKey is shared with Paystack popup.
        dispatchPromise(getPaymentRail({ category: 'subscriptions' }))
            .then((railData: unknown) => {
                const rail = resolvePaymentRail(railData as any);
                const provider = defaultCheckoutProvider(rail);
                const keySource =
                    provider === 'paystack' ? 'paystack' : provider === 'flutterwave' ? 'flutterwave' : 'stripe';
                dispatch(getPublishableKey({ source: keySource }));
            })
            .catch(() => {
                dispatch(getPublishableKey({ source: 'stripe' }));
            });
        /** If we already have the forms then do NOT fetch them again */
        if (isEmpty(systemForms) || !systemForms) {
            dispatch(getSystemForms({ tag: 'system' }));
        }
    };

    useLayoutEffect(() => {
        if (isSignedIn) dispatch(connect());
        handleGetConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSignedIn]);

    const collapseAll = () => {
        // TODO: Check if the drawer or filter is open before toggling this off

        batch(() => {
            dispatch(setShowSearchBox('off'));
            // dispatch(toggleFiler({ filterStatus: 'off', filterId: undefined }));
            dispatch(toggleDrawer({ status: 'closed' }));
            dispatch(toggleNotification({ on: false }));
            dispatch(toggleAccountModal({ on: false }));
            // dispatch(
            //     toggleFiler({
            //         filterStatus: 'off',
            //     }),
            // );
        });
    };

    const handleSearchBoxOnClick = () => {
        /** NOTE: We reworked the below to support both logged in and not logged in users */

        batch(() => {
            dispatch(getSearchSuggestions());
            dispatch(getMyActivities());
            dispatch(setShowSearchBox('on'));
            dispatch(toggleAccountModal({ on: false }));
            dispatch(toggleNotification({ on: false }));
            dispatch(toggleDrawer({ status: 'closed' }));
            dispatch(
                toggleFiler({
                    filterStatus: 'off',
                }),
            );
        });
    };

    const handleSearch = useRef(
        _.debounce((term: string) => {
            if (term.length > 3 && !searching) {
                const location = ugcSearchLocationRef.current;
                dispatch(
                    searchDiscovery({
                        searchTerm: term,
                        ...(ugcOnlyRef.current
                            ? {
                                  location: location
                                      ? {
                                            country_code: location.country_code,
                                            place: location.place,
                                        }
                                      : undefined,
                              }
                            : {}),
                    }),
                );
                if (ugcOnlyRef.current) setRecentSearches(rememberUgcSearch(term));
            }
        }, 1000),
    ).current;

    const applyBackendLocation = () => {
        if (!backendPlace) return;
        const next = {
            country_code: currentLocation?.country_code,
            place: backendPlace,
            label: backendPlace,
        };
        setUgcSearchLocation(next);
        ugcSearchLocationRef.current = next;
        if (searchTerm.length > 3) handleSearch(searchTerm);
    };

    const handleChange = (event: any) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
        handleSearch(searchTerm); // Call the debounced function
    };

    const handleClearSearch = () => {
        setSearchTerm('');
    };
    //TODO: REWORK THIS FUNCTION
    const mixPanelFunction = () => {
        if (!notificationStatus) {
            MixPanel.track(MIXPANEL_EVENT.NOTIFICATION_OPEN, {
                buttonAction: 'NOTIFICATION OPEN',
                buttonName: 'NOTIFICATION ICON',
            });
        } else {
            MixPanel.track(MIXPANEL_EVENT.NOTIFICATION_CLOSE, {
                buttonAction: 'NOTIFICATION CLOSE',
                buttonName: 'NOTIFICATION ICON',
            });
        }
    };

    const handleClearAllOpenModals = () => {
        dispatch(setShowSearchBox('off'));
        dispatch(toggleAccountModal({ on: false }));
        dispatch(
            toggleFiler({
                filterStatus: 'off',
            }),
        );
        dispatch(toggleNotification({ on: false }));
    };

    const toggleNotificationAction = () => {
        dispatch(setShowSearchBox('off'));
        dispatch(getMyNotifications());
        dispatch(toggleAccountModal({ on: false }));
        dispatch(
            toggleFiler({
                filterStatus: 'off',
            }),
        );
        dispatch(toggleNotification({ on: notificationStatus ? false : true }));
        mixPanelFunction();
        if (userNotificationCount && userNotificationCount > 0) {
            dispatch(
                updateUserConfig({
                    payload: {
                        unread_web_notifications: 0,
                    },
                }),
            );
        }
    };
    const creatorHandler = (
        creatorType: CreatorType,
        location?: CreatorLocation,
        options?: { preserveSubmissionModal?: boolean },
    ) => {
        dispatch(toggleCreatorModal({ creatorType, location }));
        if (creatorType === 'project') {
            dispatch(getMySubmissions({})); //TODO: Remove
        }
        /** Opening upload from Submit Project must keep fee/tier checkout state intact. */
        if (!options?.preserveSubmissionModal) {
            handleProjectSubmissionOpener();
        }

        dispatch(setContestForEdit(undefined));
        formContestDispatch({
            type: 'RESET',
        });
        formDispatch({
            type: 'RESET',
        });
        MixPanel.track(MIXPANEL_EVENT.PROJECT_CREATOR_CLICK, {
            buttonAction: creatorType === undefined ? 'CLOSE_PROJECT_CREATOR' : 'OPEN_PROJECT_CREATOR',
            buttonName: creatorType === undefined ? 'CLOSE_CREATOR' : 'CREATE_PROJECT',
        });
    };
    const handleContentCreatorModal = (
        creatorType: CreatorType,
        location?: CreatorLocation,
        deselectContestForSubmission?: boolean,
        shouldAutoSubmit: boolean = false,
    ) => {
        /** Keep Submit Project + fee state whenever this flow is tied to contest submission. */
        const preserveSubmissionModal = Boolean(deselectContestForSubmission);
        creatorHandler(creatorType, location, { preserveSubmissionModal });
        /** This allows to control when to prompt users to submit a project after it has been created.
         * If a user taps on create project from inside the submitter, we want to prompt them to submit that project
         * after it has been published.
         */
        if (!deselectContestForSubmission) {
            pendingContestAutoSubmitRef.current = false;
            contestUploadInFlightRef.current = false;
            dispatch(setCampaignForSubmission(undefined));
            dispatch(setAutoPublishAndSubmit(false));
        }

        if (creatorType === 'project') {
            // Open from Submit: remember intent only — wait overlay arms on real create submit.
            pendingContestAutoSubmitRef.current = Boolean(shouldAutoSubmit);
            contestUploadInFlightRef.current = false;
            dispatch(setAutoPublishAndSubmit(false));
        }

        // Avoid clearing focusCampaign on open (creatorSelector is still stale undefined here).
        if (creatorType === undefined && !creatorSelector && !deselectContestForSubmission) {
            dispatch(setFocusCampaign(undefined));
        }
    };

    const dismissContentCreatorFromSubmitFlow = () => {
        const startedUpload = contestUploadInFlightRef.current || autoPublishAndSubmit;
        if (!startedUpload) {
            pendingContestAutoSubmitRef.current = false;
            dispatch(setAutoPublishAndSubmit(false));
        }
        handleContentCreatorModal(
            undefined,
            'submissions',
            Boolean(startedUpload || pendingContestAutoSubmitRef.current || shoudlOpenSubmissionModal),
        );
    };
    const clearProject = () => {
        formDispatch({
            type: 'RESET',
        });
    };

    const handleFilterPressed = () => {
        batch(() => {
            dispatch(toggleFiler({ filterStatus: 'off', filterId: undefined }));
            dispatch(filter({ page: 0 }));
            dispatch(navigate({ routes: ROUTES.SEARCH, skipAuthentication: true })); // Keeping isRefreshed as true to prevent app being forced to loginpage for search screen
        });
        MixPanel.track(MIXPANEL_EVENT.APPLY_FILTER_CLICK, {
            buttonAction: 'SELECT_APPLY_FILTER',
            buttonName: 'APPLY FILTER',
        });
    };

    const handleCloseMediaPlayer = (mediaType: MediaType) => {
        dispatch(
            setPlayerQuery({
                isSequential: false,
                isSinglePreview: false,
            }),
        );
        dispatch(
            setmedia({
                media: null,
                mediaType: mediaType,
                submissionObject: undefined,
                playlistType: 'recommendation',
                clearCustomSuggestion: true,
            }),
        );
        const onWatchRoute =
            pathname === ROUTES.WATCH ||
            pathname.startsWith(`${ROUTES.WATCH}/`) ||
            pathname === ROUTES.ESWATCH_VIDEO ||
            pathname.startsWith(`${ROUTES.ESWATCH_VIDEO}/`);
        if (onWatchRoute) {
            setSearchParams({}, { replace: true });
        }
        dispatch(setMute(true));
    };

    const handleSelectPlaylistItem = (video: IProject, avoidRefetch?: boolean) => {
        if (video && video.video_id) {
            dispatch(
                getProjectDetails({
                    id: video.video_id as string,
                    noPlaylistRefetch: avoidRefetch ?? shouldAvoidLoadingPlaylist,
                    justFetchDetails: true,
                    projectToSet: video,
                    skipMediaSet: false,
                }),
            );
            // if (pathname === '/watch') {
            //     setSearchParams({ id: video.video_id as string });
            // }
            dispatch(setMute(false));
            dispatch(setAutoPlay(true));
        } else {
            console.log('Video not found', video);
        }
    };

    const handleAdClick = (ad: IAdvertisement) => {
        if (ad && ad._id && selectedAct) {
            dispatch(
                trackAd({
                    additionalPayload: ad,
                    action: 'clickthrough',
                    id: ad._id,
                    project: selectedAct._id,
                }),
            );
            window.open(ad.click_through, '_blank', 'noopener,noreferrer');
        }
    };

    const closeAd = () => {
        dispatch(hideAdBanner());
    };

    useEffect(() => {
        const params: any = Object.fromEntries([...searchParams]);
        if (isEmpty(params) || (!params && !params['id'])) {
            dispatch(
                setmedia({
                    media: null,
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /** Deep link: /dashboard?...&pay_submission=<id> opens checkout for an unpaid entry */
    useEffect(() => {
        const payId = searchParams.get('pay_submission');
        if (!payId || paySubmissionHandled.current) return;
        paySubmissionHandled.current = true;

        const next = new URLSearchParams(searchParams);
        next.delete('pay_submission');
        setSearchParams(next, { replace: true });

        (async () => {
            const fromState = (locationState as { submission?: ISubmission } | null)?.submission;
            const ok = await openSubmissionPaymentCheckout(dispatch, payId, {
                submission: fromState,
                contest: fromState?.contest,
                project: fromState?.project,
            });
            if (!ok) {
                paySubmissionHandled.current = false;
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    const handleCategorySelections = (doc: any) => {
        const suggestion: SearchSuggestion = doc;
        switch (suggestion.suggestionType) {
            case 'contest':
                const selectedContest: IContest = suggestion.suggestion as IContest;
                let route = replaceRouteParam(ROUTES.ESVIEW_CONTEST, 'contestId', selectedContest.slug!);
                if (selectedContest && selectedContest.kind === 'physical') {
                    route = replaceRouteParam(ROUTES.EVENT, 'contestId', selectedContest.contest_id);
                    if (selectedContest.preferred_name) {
                        route = replaceRouteParam(ROUTES.EVENT_CUSTOM, 'hostName', selectedContest.preferred_name);
                        route = replaceRouteParam(route, 'contestId', selectedContest.contest_id);
                    }
                }
                dispatch(navigate({ routes: route, skipAuthentication: true }));
                break;
            case 'talent':
                // const selectedUser: IProject = suggestion.suggestion as IUser;
                // Get User Profile here
                const profileRoute = replaceRouteParam(ROUTES.ESMY_PROFILE, 'profileId?', doc.suggestion.userName);
                dispatch(navigate({ routes: profileRoute }));
                break;
            case 'projects':
                const selectedSuggestion: IProject = suggestion.suggestion as IProject;
                dispatch(
                    getProject({
                        id: selectedSuggestion.video_id as string,
                        withNavigate: true,
                        fromAnotherScreen: true,
                    }),
                );
                break;
            default:
                return;
        }
    };

    const handleOnSearchCellClicked = (buttonType?: CellType, doc?: any) => {
        if (buttonType === 'activity' && !!doc && doc.activity) {
            const activity: ActivityResponse = doc;
            switch (activity.activity?.type) {
                case 'Project':
                    const proj = activity.activity.model as IProject;
                    dispatch(getProject({ id: proj.video_id as string, withNavigate: true, fromAnotherScreen: true }));
                    break;
                case 'Contest':
                    const cont = activity.activity.model as unknown as IContest;
                    let route = replaceRouteParam(ROUTES.ESVIEW_CONTEST, 'contestId', cont.slug!);
                    if (cont && cont.kind === 'physical') {
                        route = replaceRouteParam(ROUTES.EVENT, 'contestId', cont.contest_id);
                        if (cont.preferred_name) {
                            route = replaceRouteParam(ROUTES.EVENT_CUSTOM, 'hostName', cont.preferred_name);
                            route = replaceRouteParam(route, 'contestId', cont.contest_id);
                        }
                    }
                    dispatch(navigate({ routes: route, skipAuthentication: true }));
                    break;
                case 'User':
                case 'Talent':
                    const user = activity.activity.model as unknown as IUserSummary;
                    const profileRoute = replaceRouteParam(ROUTES.ESMY_PROFILE, 'profileId?', user.userName);
                    dispatch(navigate({ routes: profileRoute }));
                    break;
                case 'Audition':
                    const audition = activity.activity.model as unknown as IAudition;
                    const auditionRoute = replaceRouteParam(ROUTES.AUDITION_DETAIL, 'auditionId?', audition.slug);
                    dispatch(navigate({ routes: auditionRoute, skipAuthentication: true }));
                    break;
                case 'Event':
                    const event = activity.activity.model as unknown as IEvent;
                    const eventRoute = replaceRouteParam(ROUTES.EVENT_DETAILS, 'eventId?', event.slug);
                    dispatch(navigate({ routes: eventRoute, skipAuthentication: true }));
                    break;
                case 'Company':
                    const company = activity.activity.model as unknown as IEvent;
                    const companyRoute = replaceRouteParam(ROUTES.COMPANY, 'eventId?', company.slug);
                    dispatch(navigate({ routes: companyRoute, skipAuthentication: true }));
                    break;
                default:
                    return;
            }
        }

        if (buttonType === 'suggestion') {
            // Navigate to the
            handleCategorySelections(doc);
        }
        // setSearchModalVisible(false);
        dispatch(setShowSearchBox('off'));
        handleClearSearch();
    };

    const handleRightIconClicked = (buttonType?: CellType, doc?: any) => {
        if (buttonType === 'activity') {
            const activity: ActivityResponse = doc;
            dispatch(hideMyActivity({ documentId: activity && activity._id, payload: { hidden: true } }));
        }

        if (buttonType === 'suggestion') {
            handleCategorySelections(doc);
        }
    };

    const renderActivities: any[] = isSignedIn
        ? [
              {
                  label: 'Popular Search',
                  type: 'activity',
                  items: myActivity,
              },
          ]
        : [];

    const onSearchResultClicked = (data: IAutoSuggestionSearchCell) => {
        switch (data.type) {
            case 'contest':
                let route = replaceRouteParam(ROUTES.ESVIEW_CONTEST, 'contestId', data.slug);
                if (data && data.isEvent && data.contest_id) {
                    route = replaceRouteParam(ROUTES.EVENT, 'contestId', data.slug!);
                    if (data.preferred_name) {
                        route = replaceRouteParam(ROUTES.EVENT_CUSTOM, 'hostName', data.preferred_name);
                        route = replaceRouteParam(route, 'contestId', data.contest_id!);
                    }
                }
                dispatch(
                    navigate({
                        routes: `${route}?search=true`,
                        skipAuthentication: true,
                    }),
                );
                break;
            case 'project':
                dispatch(
                    getProject({
                        id: data.id as string,
                        withNavigate: true,
                        params: '?search=true',
                        fromAnotherScreen: true,
                        skipAuthentication: true,
                    }),
                );
                dispatch(setMute(false));
                break;
            case 'talent':
                const profileRoute = replaceRouteParam(ROUTES.ESMY_PROFILE, 'profileId?', data.id);
                dispatch(navigate({ routes: `${profileRoute}?search=true` }));
                break;
            case 'event':
                const eventRoute = replaceRouteParam(ROUTES.EVENT_DETAILS, 'eventId?', data.slug);
                dispatch(navigate({ routes: `${eventRoute}?search=true`, skipAuthentication: true }));
                break;
            case 'audition':
                const auditionRoute = replaceRouteParam(ROUTES.AUDITION_DETAIL, 'auditionId?', data.slug);
                dispatch(navigate({ routes: `${auditionRoute}?search=true`, skipAuthentication: true }));
                break;
            case 'company':
                const companyRoute = replaceRouteParam(ROUTES.COMPANY, 'id', data.slug);
                dispatch(navigate({ routes: `${companyRoute}?search=true`, skipAuthentication: true }));
                break;
            case 'campaign': {
                const campaignRoute = replaceRouteParam(ROUTES.UGC_CAMPAIGN_DETAIL, 'campaignId', data.id);
                dispatch(navigate({ routes: `${campaignRoute}?search=true`, skipAuthentication: true }));
                break;
            }
            default:
                return;
        }
        handleClearSearch();
        dispatch(setShowSearchBox('off'));
    };

    const onSeeAllResultClicked = () => {
        batch(() => {
            dispatch(navigate({ routes: ROUTES.SEARCH }));
            dispatch(setViewAll());
            dispatch(setShowSearchBox('off'));
        });
        handleClearSearch();
    };

    const handleUserIconClicked = (mediaType: MediaType, user?: UserSummary) => {
        if (user) {
            handleCloseMediaPlayer(mediaType);
            const profileRoute = replaceRouteParam(ROUTES.ESMY_PROFILE, 'profileId?', user.userName);
            dispatch(navigate({ routes: profileRoute }));
        }
    };

    const handleSubmitContentCreator = () => {
        if (creatorSelector === 'project') {
            const stateClone = parseProjecPaload({ ...state });
            if (stateClone.project_type && isArray(stateClone.project_type)) {
                stateClone['project_type'] = state.project_type[0];
            }

            // /** Force set the mediaType */
            if (!stateClone.media_type) {
                stateClone.media_type = stateClone.media_type === 'picture' ? 'picture' : 'video';
            }
            setPendingPostAutomationIntent(Boolean(state.post_automation));
            const shouldArmContestAutoSubmit =
                pendingContestAutoSubmitRef.current || Boolean(shoudlOpenSubmissionModal);
            // Arm wait overlay before closing creator so Dialog onClose cannot clear it.
            if (shouldArmContestAutoSubmit) {
                contestUploadInFlightRef.current = true;
                dispatch(setAutoPublishAndSubmit(true));
            }
            pendingContestAutoSubmitRef.current = false;
            dispatch(createProject(stateClone));
            handleContentCreatorModal(undefined, 'submissions', true); // Ensured that the submissions location is kept alive after we submit. Allows us to trigger the submisison prompt
            formDispatch(initialState);
            formDispatch({
                type: 'RESET',
            });
        } else if (creatorSelector === 'offsite_campaign') {
            // Handle offsite campaign submission
            const offsiteCampaignPayload = { ...offsiteCampaignState } as any;
            dispatch(createOffsiteCampaign(offsiteCampaignPayload));
            handleContentCreatorModal(undefined);
            formOffsiteCampaignDispatch({
                type: 'RESET',
            });
        } else {
            const payload = parseContestPayload(contestState, initialContestValues);

            if (initialContestValues && initialContestValues._id) {
                dispatch(
                    updateContest({
                        documentId: initialContestValues._id,
                        payload,
                    }),
                );
            } else {
                dispatch(createContest(payload));
            }
            handleContentCreatorModal(undefined);
            formContestDispatch(contestState);
            formContestDispatch({
                type: 'RESET',
            });
        }
    };

    const handleClearToast = () => dispatch(toggleToast({ message: '', state: false }));

    const handleToastDismissAndNavigate = () => {
        batch(() => {
            toast.dismiss(toastId.current);
            handleClearToast();
            dispatch(navigate({ routes: ROUTES.SEARCH }));
        });
    };

    const handleBottomToast = useCallback(() => {
        toastId.current = showToastMessage(
            <CustomToast message={message} onClick={handleToastDismissAndNavigate} />,
            'success',
            20000,
            handleClearToast,
            undefined,
            undefined,
            'bottom-right',
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleProjectSubmissionOpener = (controlled?: boolean) => {
        /** Nested ContentCreator / upload wait must not dismiss the submitter. */
        if (contentCreatorModalVisible || showContestUploadWait) return;
        /** When closeIcon is clicked */
        dispatch(setSubmissionPrompt(false));
        if (controlled) {
            dispatch(setCampaignForSubmission(undefined));
        }
        dispatch(setAutoPublishAndSubmit(false));
        dispatch(setSubmissionModalState({ open: false }));
    };
    const handleProjectSubmission = (
        contest: string,
        project: string,
        reedemableCode?: string,
        category?: string,
        saleId?: string,
        chosen_tier?: { label?: string; fee?: number },
        existingSubmissionId?: string,
    ) => {
        const request = existingSubmissionId
            ? completeSubmissionPayment({ submissionId: existingSubmissionId, saleId })
            : submitProject({ contest, project, reedemableCode, category, saleId, chosen_tier });
        dispatchPromise(request)
            .then(() => {
                handleProjectSubmissionOpener();
            })
            .catch(() => {
                handleProjectSubmissionOpener();
            });
    };
    const handleOnActLikePressed = () => {
        if (selectedAct) {
            dispatch(
                likeProject({
                    like_category: 'project',
                    like_type: 'like',
                    projectId: selectedAct?._id as string,
                    like_origin: 'home',
                    location: 'home',
                }),
            );
        }
    };

    const handleOnDeleteLike = (like: ILike) => {
        dispatch(
            deleteLike({
                documentId: like._id,
                /** The below allows us update the like count on the discovery page */
                payload: 'home',
                additionalPayload: like.project,
            }),
        );
    };

    /** This is no longer being used Remove */
    const handleOnCommentSend = (
        text: string,
        comment?: TComment,
        isReply?: boolean,
        project?: IActSummary,
        isEdit?: boolean,
    ) => {
        if (isEdit && comment) {
            dispatch(
                updateComment({
                    documentId: comment?._id,
                    payload: text,
                }),
            );
        } else {
            dispatch(
                leaveComment({
                    comment: text,
                    project: project as any,
                    commentId: comment?._id,
                    commentType: 'project',
                    isReply: isReply,
                    parentComment: comment,
                    location: 'home',
                }),
            );
        }
    };

    const handleCloseSuggestionBox = () => {
        dispatch(setUsersFirstProjectSuggestionBox(false));
        setShowInfoBox(false);
    };

    const handleShowProjectCreatorGudie = () => {
        dispatch(setShowProjectCreatorGuide(true));
        handleCloseSuggestionBox();
        dispatch(
            updateUserConfig({
                payload: {
                    already_created_project: true,
                },
            }),
        );
    };

    const handleViewProject = () => {
        if (currentProjectInCreation) {
            dispatch(
                navigate({
                    routes: `${ROUTES.ESMY_VIDEOS}?isNewEdit=true&project=${currentProjectInCreation.video_id}&edit=true&publish_button=true`,
                }),
            );
        }
        handleCloseSuggestionBox();
    };

    const handleProjectUploadCompletion = useCallback(() => {
        if (isProjectProcessingDone) {
            if (shouldShowSuggestionBox && !userAlreadyCreatedProject && isSignedIn && showInfoox) {
                dispatch(setUsersFirstProjectSuggestionBox(true));
            }
            //TODO CHECK If needed
            if (!!uploadMessage) {
                showToastMessage(uploadMessage, 'success', 6000, () => {
                    dispatch(
                        mediaForgeWorker({
                            status: 'ignore',
                            mediaForgeMessage: '',
                        }),
                    );
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProjectProcessingDone]);

    useEffect(() => {
        handleProjectUploadCompletion();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleProjectUploadCompletion]);

    const handleOnDeleteComment = (comment: TComment) => {
        dispatch(
            deleteComment({
                documentId: comment._id,
                additionalPayload: comment._id,
                payload: comment,
            }),
        );
    };

    const handleVoteIconClicked = catchAsync(async (submisisons: ISubmission[]) => {
        /** Cast Vote For users that are logged in without the voting modal */
        dispatch(resetVoteFlow());
        dispatch(
            setVotingFlow({
                submissions: submisisons,
                showVotingModal: true,
            }),
        );
    });

    const handleDismissVoting2Fa = () => {
        dispatch(setVoting2Fa(false));
    };

    const handleCommentReaction = (like_type: Likes, comment: TComment) => {
        if (!likingInProgress) {
            if (like_type === 'like') {
                dispatch(
                    likeComment({
                        commentId: comment._id,
                        like_category: 'comment',
                        like_type: like_type,
                        like_origin: 'home',
                    }),
                );
            } else {
                const likeToBeDeleted = userLikes.find(
                    like =>
                        like.comment &&
                        like.comment === comment._id &&
                        like.like_type === 'like' &&
                        like.like_category === 'comment',
                );
                if (likeToBeDeleted) {
                    dispatch(
                        deleteLike({
                            documentId: likeToBeDeleted._id,
                            additionalPayload: likeToBeDeleted,
                        }),
                    );
                }
            }
        } else {
            console.log('Liking In Progress');
        }
    };

    const handleReportModal = () => {
        dispatch(openReportModal(!reportModalOpen));
    };

    const handleToggleCookiesDrawer = (on: boolean) => {
        dispatch(toggleCookiesModal({ on }));
    };

    const handleSendReport = (payload: ReportPayload) => {
        dispatch(sendReport(payload));
        handleReportModal();
    };

    const handleViewUpdate = (payload: ICreateView) => {
        dispatch(createView(payload));
    };

    const handleSubmitPhoneNumberForVerification = async (next?: () => void, phone?: string, onEnd?: () => void) => {
        if ((phone || isSignedIn) && currentSubmission) {
            dispatchPromise(
                initaiet2FAForVote({
                    phone_number: phone,
                    submission_id: currentSubmission?._id,
                }),
            )
                .then(res => {
                    /** Vote is successful, end the transaction */
                    onEnd && onEnd();
                    dispatch(
                        setVotingFlow({
                            submissions: [],
                            showVotingModal: false,
                        }),
                    );
                })
                .catch(e => {
                    onEnd && onEnd();
                    dispatch(
                        setVotingFlow({
                            submissions: [],
                            showVotingModal: false,
                        }),
                    );
                });
        }
    };

    const handleClearInAppNotification = () => dispatch(clearInAppNotification());

    const handleOnEndReach = (isPlaylist?: boolean, playlistId?: string) => {
        if (isPlaylist && playlistId) {
            const { currentPage, hasNextPage } = playlistPagination;
            if (hasNextPage && currentPage) {
                dispatch(
                    getPlaylist({
                        id: playlistId,
                        page: currentPage + 1,
                        skipAuthentication: true,
                        withNavigate: false,
                    }),
                );
            }
        } else {
            const { isSubmissionList, parameter } = (selectedNebulaSuggestion as INebulaSuggestion) || {};
            /** Get the current param and replace the value of the page */
            const { currentPage, limit, loading, param, canLoadMore } = projectQuery;
            if (!loading && canLoadMore) {
                const newPage = currentPage ? currentPage + 1 : 1;
                const newParam = isSubmissionList
                    ? replacePageValue(
                          `${parameter}?limit=${en_config.RESULT_LIMIT}&page=${newPage}` as string,
                          newPage,
                      )
                    : replacePageValue(param as string, newPage);
                dispatch(
                    getProjects({
                        isFiltered: true,
                        page: newPage,
                        params: newParam,
                        limit,
                        isSubmissionList,
                    }),
                );
            }
        }
    };

    const handleReadNotification = (notification: WebNotification) => {
        batch(() => {
            if (!notification.page) {
                /** Only mark notification as Read when it is not linked to a specific page */
                dispatch(readNotification(notification));
            }
            dispatch(toggleNotification({ on: false }));
        });
    };
    const handleHideNotification = (notification: WebNotification) => {
        dispatch(
            updateNotification({
                documentId: notification._id,
                payload: {
                    seen: true,
                    hidden: true,
                },
            }),
        );
    };
    const handleReadDeleteNotification = (notification: WebNotification) => {
        dispatch(
            deleteNotification({
                documentId: notification._id,
            }),
        );
    };

    const handleNotificationSettingsClicked = () => {
        MixPanel.track(MIXPANEL_EVENT.SETTINGS_CLICK, {
            buttonAction: 'OPEN_SETTINGS',
            buttonName: 'SETTINGS',
        });
        dispatch(toggleNotification({ on: false }));
        dispatch(
            navigate({
                routes: ROUTES.ACCOUNT_NOTIFICATIONS,
            }),
        );
    };

    const handleOnEndPress = (showGuide?: boolean) => {
        batch(() => {
            dispatch(
                updateUserConfig({
                    payload: {
                        show_introduction: false,
                        show_app_guide: showGuide,
                    },
                }),
            );
            if (showGuide) {
                dispatch(
                    navigate({
                        routes: ROUTES.FEED,
                    }),
                );
            }
        });
    };

    /** This should handle Publishing created project */
    const handleOnFinalStepOnProjectGuide = (showGuide?: boolean) => {
        if (showGuide && currentProjectInCreation) {
            dispatch(
                publishProject({
                    documentId: currentProjectInCreation._id,
                    additionalPayload: 'from guide',
                }),
            );
        }
        dispatch(setShowProjectCreatorGuide(false));
    };

    const handleUserUpdateForIntroduction = catchAsync(async (payload: any) => {
        await dispatchPromise(updateUserProfile(payload));
    });

    const handleGetSuggestedThspians = (userType: string[]) => {
        batch(() => {
            dispatch(
                getMyFollowing({
                    page: 1,
                    limit: en_config.RESULT_LIMIT,
                }),
            );
            dispatch(getSuggestedThspians({ user_type: userType }));
        });
    };

    const handleFollowThspian = (user: ITopUser | IUserSummary) => {
        if (!followingInProgress) {
            dispatch(
                followAThspian({
                    following: user._id,
                }),
            );
        }
    };

    const handleNebularSuggestion = (suggestion: INebulaSuggestion) => {
        dispatch(
            selectNebulaSuggestion({
                ...suggestion,
                isSetType: 'select',
            }),
        );
        dispatch(
            getProjects({
                page: 1,
                isPlaylistFetch: true,
                params: suggestion.parameter,
                playlistType: suggestion.playlistType,
                shouldSetMedia: false,
                isSubmissionList: suggestion.isSubmissionList,
            }),
        );
    };

    useEffect(() => {
        if (open && message) {
            handleBottomToast();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, message]);

    useEffect(() => {
        /** This Checks is there is an upload still currently in progress then retriggeres it */
        if (isProjectProcessing && currentUploadPayload) {
            dispatch(restartUploadAfterReload(currentUploadPayload));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch(
            getAd({
                params: '',
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const hasOnboardingInterests = (user?.interest?.length ?? 0) > 0 && (user?.user_type?.length ?? 0) > 0;
        if (isSignedIn && !user?.shown_people_of_interest && hasOnboardingInterests && !showAuthModal) {
            setShowPeopleModal(true);
        } else if (showAuthModal || !hasOnboardingInterests) {
            setShowPeopleModal(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, isSignedIn, showAuthModal]);

    const buzzBridgeCampaignWorkspaceMatch = useMatch({ path: ROUTES.BUZZ_BRIDGE_CAMPAIGN_WORKSPACE, end: true });

    /** Campaign / UGC / Buzz / event detail pages use a top hero; use toolbar-only offset (no extra band) below the fixed header. */
    const isFullBleedHeroUnderHeader =
        /^\/campaign\/[^/]+$/.test(pathname) ||
        /^\/campaigns\/[^/]+$/.test(pathname) ||
        /^\/buzzbridge\/[^/]+$/.test(pathname) ||
        /^\/event\/[^/]+$/.test(pathname);

    // Check for route aliases when pathname changes
    useEffect(() => {
        if (pathname) {
            dispatch(getRouteAlias({ routePath: pathname }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    // Close share modal on navigation
    useEffect(() => {
        if (isShareStatusActive) {
            dispatch(setShareModalStatus({ status: false, title: undefined, url: undefined }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    // Handle interstitial ads
    useEffect(() => {
        if (interstitialAds.length === 0 || showInterstitialAd) {
            return;
        }

        // Get shown ad IDs from sessionStorage
        const shownAdIdsKey = 'interstitial_ads_shown';
        const shownAdIdsJson = sessionStorage.getItem(shownAdIdsKey);
        const shownAdIds: string[] = shownAdIdsJson ? JSON.parse(shownAdIdsJson) : [];

        // Filter ads that match the current page and haven't been shown
        const availableAds = interstitialAds.filter(ad => {
            // Check if ad has display_pages and if current pathname matches
            if (ad.display_pages && ad.display_pages.length > 0) {
                const matchesPage = ad.display_pages.some(page => {
                    // Support exact match or pattern matching
                    if (`/${page}` === pathname) return true;
                    // Support wildcard patterns like '/feed/*'
                    const pattern = page.replace(/\*/g, '.*');
                    const regex = new RegExp(`^${pattern}$`);
                    return regex.test(pathname);
                });
                if (!matchesPage) return false;
            }
            // Check if ad hasn't been shown in this session
            return !shownAdIds.includes(ad._id);
        });

        if (availableAds.length > 0) {
            // Select a random ad
            const randomIndex = Math.floor(Math.random() * availableAds.length);
            const selectedAd = availableAds[randomIndex];
            setSelectedInterstitialAd(selectedAd);
            setShowInterstitialAd(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [interstitialAds, pathname]);

    const handleInterstitialAdClose = useCallback(() => {
        if (selectedInterstitialAd) {
            // Mark ad as shown in sessionStorage
            const shownAdIdsKey = 'interstitial_ads_shown';
            const shownAdIdsJson = sessionStorage.getItem(shownAdIdsKey);
            const shownAdIds: string[] = shownAdIdsJson ? JSON.parse(shownAdIdsJson) : [];

            if (!shownAdIds.includes(selectedInterstitialAd._id)) {
                shownAdIds.push(selectedInterstitialAd._id);
                sessionStorage.setItem(shownAdIdsKey, JSON.stringify(shownAdIds));
            }
        }
        setShowInterstitialAd(false);
        setSelectedInterstitialAd(null);
    }, [selectedInterstitialAd]);

    // Handles following and unfollowng for the Horizontal player, possibly can be used for the vertical too
    const handleOnFollowClick = (userToFollow?: UserSummary) => {
        if (!followingInProgress) {
            if (userToFollow && !userToFollow?.user_following && user) {
                dispatch(followAThspian({ following: userToFollow?._id, from: 'profile' }));
                MixPanel.track(MIXPANEL_EVENT.FOLLOWED_A_THSPIAN, {
                    follower: user._id,
                    following: userToFollow.userName,
                });
            } else if (
                user &&
                userToFollow &&
                userToFollow.user_following &&
                userToFollow.user_follow_interaction &&
                !isEmpty(userToFollow.user_follow_interaction)
            ) {
                dispatch(
                    unfollowThspian({
                        documentId: userToFollow.user_follow_interaction[0]._id,
                        additionalPayload: userToFollow.user_follow_interaction[0],
                    }),
                );
                MixPanel.track(MIXPANEL_EVENT.UNFOLLOWED_A_THSPIAN, {
                    follower: user.userName,
                    following: userToFollow.userName,
                });
            }
        } else {
            console.log('Rapid tap detected, Slow down');
        }
    };

    const handleOnSwipeUp = (index: number) => {
        if (currentFeedSelector && !showVotingBooth && !isShareStatusActive) {
            dispatch(
                setmedia({
                    media: currentFeedSelector[index],
                    mediaType: 'act',
                }),
            );
            handleSelectPlaylistItem(currentFeedSelector[index], true);
            dispatch(setMute(systemMute));
            if (pathname === ROUTES.ESWATCH_VIDEO || pathname === ROUTES.WATCH) {
                setSearchParams({ id: currentFeedSelector[index].video_id as string });
            }
        }
    };

    const handleOnSwipeDown = (index: number) => {
        if (currentFeedSelector && !showVotingBooth && !isShareStatusActive) {
            dispatch(
                setmedia({
                    media: currentFeedSelector[index],
                    mediaType: 'act',
                }),
            );
            handleSelectPlaylistItem(currentFeedSelector[index], true);
            dispatch(setMute(systemMute));
            if (pathname === ROUTES.ESWATCH_VIDEO || pathname === ROUTES.WATCH) {
                setSearchParams({ id: currentFeedSelector[index].video_id as string });
            }
        }
    };

    const handleLoadMore = () => {
        if (canLoadMore && initialProjectId) {
            dispatch(
                getFeed({
                    firstProjectId: initialProjectId,
                    page: page + 1,
                }),
            );
        }
    };

    const handleOnUploadCancel = () => {
        dispatch(terminateUplaod());
    };

    const handleOnResumeUpload = () => {
        dispatch(resumeUpload(undefined));
    };

    const handleOnPauseUplaod = () => {
        dispatch(pauseUpload('Upload currently paused.'));
    };

    const handleOnProjectSubmissionBoxClose = () => {
        dispatch(setCampaignForSubmission(undefined));
        dispatch(setSubmissionPrompt(false));
    };
    const handleOnShareModalClose = () => {
        MixPanel.track(MIXPANEL_EVENT.CLOSE_SHARE_CONTEST_MODAL, {
            buttonAction: 'SHARE MODAL CLOSE',
            buttonName: 'SHARE MODAL CLOSE',
        });
        dispatch(setShareModalStatus({ status: false, title: undefined, url: undefined }));
    };

    const handleSetCampaignFocus = (contest?: IContest) => {
        /** Focus only — auto-publish is reserved for the submission-modal upload icon path. */
        dispatch(setFocusCampaign(contest));
    };

    const handleSetCategoryForSubmission = (category: any) => {
        dispatch(setCategoryForSubmission(category));
    };

    const filterToRender = device.isMobile ? (
        <EsFiltersMobile
            onChangeFilterCategory={handFilterToggle}
            filterList={currentFilters}
            onChangeFilterSubCategory={handleFilterSubCategorySelection}
            filterSelections={selectedFilterSubCategory}
            onApplyFilterPressed={handleFilterPressed}
            onClearFilter={handleClearFilters}
            disableFilter={disableFilterButton}
        />
    ) : (
        <EsFiltersDesktop
            onChangeFilterCategory={handFilterToggle}
            filterList={currentFilters}
            onChangeFilterSubCategory={handleFilterSubCategorySelection}
            filterSelections={selectedFilterSubCategory}
            onClearFilterPressed={handleClearFilters}
            onApplyFilterPressed={handleFilterPressed}
            disableApplyFilter={disableFilterButton}
        />
    );
    const handleDeletePrize = (prize: PrizeD) => {
        dispatch(
            deleteAwardCategory({
                documentId: prize._id!,
                additionalPayload: prize,
            }),
        );
    };

    const handleFormsOnClose = () => {
        dispatch(setSystemForm(undefined));
    };

    const handleCloseAccountSubscriptionModal = () => {
        dispatch(toggleSubscriptionModal(false));
    };

    return (
        <>
            <ReferralUrlCapture />
            {systemLoading && <Loading />}
            <Dropzone
                onDrop={onDrop}
                maxFiles={1}
                disabled={projectActivelyInCreation}
                maxSize={deviceUploadLimit}
                minSize={en_config.MIN_SIZE}
                accept={parseFileFormats(globalMediaControl, ['video/*'])}>
                {({ getRootProps, isDragActive, open, isDragReject }) => (
                    <Box className={classes.appLayout} {...getRootProps()} onClick={() => {}}>
                        {isDragActive && device.isDesktop && !contentCreatorModalVisible && (
                            <Box
                                sx={{
                                    position: 'fixed',
                                    background: 'rgba(0,0,0,0.8)',
                                    width: '100vw',
                                    height: '100vh',
                                    zIndex: 9999,
                                    top: 0,
                                    right: 0,
                                }}>
                                <Box className={classes.dropBox}>
                                    <CloudUploadIcon fontSize="large" color="primary" />
                                    <Typography
                                        style={{
                                            fontFamily: FONT_ENUM.REGULAR_HEADER,
                                            color: theme[themeStyle].true_white,
                                            fontSize: '16px',
                                            alignSelf: 'center',
                                        }}>
                                        {strings.drop_to_create_project}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        <Suspense fallback={<Loading disableBG />}>
                            <InAppNotification
                                isVisible={!!inAppNotification?.message}
                                text={inAppNotification?.message}
                                onClosePress={handleClearInAppNotification}
                            />
                        </Suspense>
                        {/** Project creation Modal */}
                        <Suspense fallback={<Loading disableBG />}>
                            <IntroductionModal
                                open={shoowProjectCreatorGuide as boolean}
                                steps={projectCreationSeps}
                                onEndPressed={handleOnFinalStepOnProjectGuide}
                                onClickFollow={() => {}}
                                userFollowing={[]}
                                duration={1.5}
                            />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <CheckoutModal />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <InfoBox
                                onClose={handleCloseSuggestionBox}
                                visible={showProjectSuggestionBox}
                                onPublishProject={handleShowProjectCreatorGudie}
                                onViewProject={handleViewProject}
                            />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <ShareModal
                                isOpen={(isShareStatusActive as boolean) ?? false}
                                onClose={handleOnShareModalClose}
                                shareUrl={url as string}
                                title={title as string}
                            />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <IntroductionModal
                                open={showIntroductionFlow}
                                steps={introductionSteps}
                                onEndPressed={handleOnEndPress}
                                onClickFollow={handleFollowThspian}
                                user={user}
                                updateUser={handleUserUpdateForIntroduction}
                                getSuggestedThspians={handleGetSuggestedThspians}
                                loading={fetchingSuggestedThspians}
                                suggestedThspians={suggestedThspians}
                                userFollowing={userFollowing}
                            />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <PeopleModal
                                open={showPeopleModal}
                                onClose={() => setShowPeopleModal(false)}
                                userType={user?.user_type || []}
                            />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <InterestModal
                                open={interestModalOpen ?? false}
                                onClose={() => dispatch(toggleInterestModal({ on: false }))}
                            />
                        </Suspense>

                        {/** Voting Flow */}
                        <Suspense fallback={<Loading disableBG />}>
                            <VotingBooth submissions={submissions} openVotingBooth={showVotingBooth} />
                        </Suspense>

                        {/** Forms Flow */}
                        <Suspense fallback={<Loading disableBG />}>
                            {selectedSystemForm && (
                                <GenericFormFiller
                                    initialStateForm={selectedSystemForm}
                                    onClose={handleFormsOnClose}
                                    open={!!selectedSystemForm}
                                />
                            )}
                        </Suspense>

                        {!!selectedAct && (
                            <Suspense fallback={<Loading disableBG />}>
                                <VerticalVideoPlayer
                                    modalOpen={actPlayerOpen}
                                    onHandleVotingModalClose={handleDismissVoting2Fa}
                                    openVotngVerificationModal={showVoting2Fa}
                                    onClose={() => handleCloseMediaPlayer('act')}
                                    project={selectedAct}
                                    comments={selectedProjectComments}
                                    userLikes={userLikes}
                                    onLikePressed={() => handleOnActLikePressed()}
                                    onDeleteLike={handleOnDeleteLike}
                                    onCommentSend={handleOnCommentSend}
                                    onReactionPress={(like_type, comment) => handleCommentReaction(like_type, comment)}
                                    onDeleteComment={handleOnDeleteComment}
                                    playlist={currentPlayListSelection}
                                    onReportClick={handleReportModal}
                                    onCoCreatorClick={() => {}}
                                    onDetailsClick={() => {}}
                                    onViewUpdate={handleViewUpdate}
                                    isVotingEnabled={isVotingEnabled}
                                    votingStartDate={votingStartDate}
                                    isUserJuryEntitled={isUserJuryEntitled}
                                    onSubmitPhonenumberForVerification={handleSubmitPhoneNumberForVerification}
                                    onVoteClicked={handleVoteIconClicked}
                                    hasVoted={false}
                                    onClickUserIcon={user => handleUserIconClicked('act', user)}
                                    feed={currentFeedSelector as unknown as IActSummary[]}
                                    onSwipeDown={handleOnSwipeDown}
                                    onSwipeUp={handleOnSwipeUp}
                                    loadMoreFeed={handleLoadMore}
                                    voteOtpSendingInProgress={voteOtpSendingInProgress}
                                    startingIndex={startingIndex}
                                    currentVideoDetails={currentVideoDetails}
                                    onClickPlaylistItem={handleSelectPlaylistItem}
                                    onAdClick={handleAdClick}
                                    closeAd={closeAd}
                                />
                            </Suspense>
                        )}
                        <Suspense fallback={<Loading disableBG />}>
                            <ReportModal
                                open={reportModalOpen}
                                onSubmit={handleSendReport}
                                onClose={handleReportModal}
                                project={selectedAct as unknown as IProject} // Fis this to take type IProject instead of ActSummary
                            />
                        </Suspense>

                        <MediaReportConsole isVisible={false} onClosePress={() => {}} mediaForge={mediaForge} />

                        <Suspense fallback={<Loading disableBG />}>
                            <ProjectSubmissionBox
                                visible={showProjectSubmissionPrompt}
                                contest={selectedContestForSubmission!}
                                project={currentProjectInCreation}
                                onClose={handleOnProjectSubmissionBoxClose}
                                onDisagre={handleOnProjectSubmissionBoxClose}
                                onAgree={() => {
                                    const categories = selectedContestForSubmission?.categories ?? [];
                                    const needsPayment = categories.some(categoryRequiresSubmissionPayment);
                                    if (needsPayment) {
                                        // Paid categories must go through CampaignSubmitter checkout.
                                        dispatch(setSubmissionPrompt(false));
                                        dispatch(
                                            setSubmissionModalState({
                                                open: true,
                                                selectedCategory:
                                                    findContestSubmissionCategory(selectedContestForSubmission),
                                            }),
                                        );
                                        return;
                                    }
                                    handleProjectSubmission(
                                        selectedContestForSubmission?._id!,
                                        currentProjectInCreation._id,
                                    );
                                }}
                            />
                        </Suspense>
                        <Suspense fallback={<Loading disableBG />}>
                            <CampaignSubmitter
                                open={shoudlOpenSubmissionModal}
                                onClose={controlled => handleProjectSubmissionOpener(controlled)}
                                selectedContest={selectedContestForSubmission}
                                setCategoryForSubmission={handleSetCategoryForSubmission}
                                existingSubmissionId={existingPaySubmissionId}
                                onSubmit={({
                                    contestId,
                                    projectId,
                                    reedemableCode,
                                    category,
                                    saleId,
                                    chosen_tier,
                                    existingSubmissionId,
                                }) =>
                                    handleProjectSubmission(
                                        contestId,
                                        projectId,
                                        reedemableCode,
                                        category,
                                        saleId,
                                        chosen_tier,
                                        existingSubmissionId || existingPaySubmissionId,
                                    )
                                }
                                onClickHandle={() => {}}
                                globalMediaControl={globalMediaControl}
                                state={{}}
                                liveCampaigns={liveCampaigns}
                                initialCampaignSelection={focusCampaign}
                                setFocusContest={handleSetCampaignFocus}
                                onCreateNewProjectClick={shouldAutoSubmit => {
                                    if (shouldAutoSubmit) {
                                        handleSetCampaignFocus(selectedContestForSubmission);
                                    }
                                    handleContentCreatorModal(
                                        'project',
                                        'submissions',
                                        true,
                                        Boolean(shouldAutoSubmit),
                                    );
                                }}
                            />
                        </Suspense>
                        <UploadWaitModal open={showContestUploadWait} />

                        {!!currentVideo && pathname !== ROUTES.WATCH && (
                            <Suspense fallback={<Loading disableBG />}>
                                <HorizontalVideoPlayerModal
                                    suggestion={nebulaSuggestion}
                                    selectedNebulaSuggestion={selectedNebulaSuggestion}
                                    open={playerOpen}
                                    onClose={() => handleCloseMediaPlayer('video')}
                                    currentVideo={currentVideo}
                                    playlist={currentPlayListSelection}
                                    comments={currentVideoComments as TComment[]}
                                    onClickPlaylistItem={handleSelectPlaylistItem}
                                    onViewUpdate={handleViewUpdate}
                                    onEndReach={handleOnEndReach}
                                    playlistLoading={gettingPlaylist} // Change this to map directly to a gettingPlaylist value
                                    commentsLoading={false}
                                    onDeleteComment={handleOnDeleteComment}
                                    isSinglePreview={isSinglePreview}
                                    onSelectTag={handleNebularSuggestion}
                                    onClickFollow={handleOnFollowClick}
                                    onClickUserIcon={user => handleUserIconClicked('video', user)}
                                    onSubmitPhonenumberForVerification={handleSubmitPhoneNumberForVerification}
                                    voteOtpSendingInProgress={voteOtpSendingInProgress}
                                    startingIndex={startingIndex}
                                    onHandleVotingModalClose={handleDismissVoting2Fa}
                                    openVotngVerificationModal={showVoting2Fa}
                                    onVoteClicked={handleVoteIconClicked}
                                    currentVideoDetails={currentVideoDetails}
                                    onAdClick={handleAdClick}
                                    closeAd={closeAd}
                                />
                            </Suspense>
                        )}
                        {/** Create Camapaign Modal */}
                        <Suspense fallback={<Loading disableBG />}>
                            <ContentCreator
                                onClose={dismissContentCreatorFromSubmitFlow}
                                open={contentCreatorModalVisible}
                                contentType={creatorSelector}
                                onSubmit={handleSubmitContentCreator}
                                setCategoryForSubmission={handleSetCategoryForSubmission}
                                onClickHandle={() => {}}
                                onCloseClick={dismissContentCreatorFromSubmitFlow}
                                onDrop={onDrop}
                                liveCampaigns={liveCampaigns}
                                initialCampaignSelection={focusCampaign}
                                setFocusContest={handleSetCampaignFocus}
                                state={
                                    creatorSelector === 'project'
                                        ? state
                                        : creatorSelector === 'offsite_campaign'
                                        ? offsiteCampaignState
                                        : contestState
                                }
                                updateField={updateCreateProjectFields}
                                globalMediaControl={globalMediaControl}
                                initialContestState={initialContestValues}
                                onClearProject={clearProject}
                                deleteAward={handleDeletePrize}
                            />
                        </Suspense>

                        {!!selectedRole && (
                            <Suspense fallback={<Loading disableBG />}>
                                <RoleDialogue
                                    open={!!selectedRole}
                                    role={selectedRole}
                                    onSubmit={() => {
                                        console.log('sone');
                                    }}
                                />
                            </Suspense>
                        )}

                        <Suspense fallback={<Loading disableBG />}>
                            <RecommendationDialogue open={!!recommendation} />
                        </Suspense>

                        {/* Cookies Prefrence Modal */}
                        <Suspense fallback={null}>
                            <CookiePreferenceDrawer
                                modalOpen={cookiesDrawerOpen}
                                toggleDrawer={handleToggleCookiesDrawer}
                                fullscreen={device.isMobile}
                            />
                        </Suspense>
                        <Suspense fallback={null}>
                            <CookieFooter onToggleCookiesDrawer={handleToggleCookiesDrawer} />
                        </Suspense>

                        {/** Main app shell (sidebar + header + Outlet) */}
                        <Box className={classes.mainShell}>
                            <Suspense fallback={<Loading disableBG />}>
                                <EsSideBarAndHeader
                                    onNotificationClick={handleReadNotification}
                                    clearAllOpenModals={handleClearAllOpenModals}
                                    isUserJuryEntitled={isUserJuryEntitled}
                                    isUserCastingDirectorEntitled={isUserCastingDirectorEntitled}
                                    progress={progress}
                                    isProjectProcessing={isProjectProcessing}
                                    handleOnClose={handleOnUploadCancel}
                                    loadingNotifications={gettingNotifications}
                                    disableCreateProject={projectActivelyInCreation}
                                    handleNotificationSettingsClicked={handleNotificationSettingsClicked}
                                    onNotificationDeleteClick={handleReadDeleteNotification}
                                    onNotificationHideClick={handleHideNotification}
                                    openNotification={notificationStatus as boolean}
                                    handleLogout={handleLogout}
                                    onSearchResultClicked={onSearchResultClicked}
                                    onSeeAllPressed={onSeeAllResultClicked}
                                    onRightIconClicked={handleRightIconClicked}
                                    onSearchCellClicked={handleOnSearchCellClicked}
                                    disableFilter={disableFilterButton}
                                    onApplyFilterPressed={handleFilterPressed}
                                    onToggleNotification={toggleNotificationAction}
                                    onClickCreateProject={() => handleContentCreatorModal('project')}
                                    notifications={userNotifications}
                                    notificationCount={userNotificationCount}
                                    openNotifications={notificationStatus as boolean}
                                    openAccountModal={accountModalStatus as boolean}
                                    searchItems={[
                                        ...renderActivities,
                                        {
                                            label: 'Suggestion',
                                            items: suggestions,
                                            type: 'suggestion',
                                        },
                                    ]}
                                    activity={myActivity}
                                    isSearch={searchTerm.length > 3}
                                    autoSuggestedSearch={searchResults?.item}
                                    standardTextFieldProps={{
                                        onChange: handleChange,
                                        value: searchTerm,
                                    }}
                                    ugcOnly={ugcOnly}
                                    searchLocationLabel={ugcSearchLocation?.label || ''}
                                    currentLocationLabel={backendPlace}
                                    recentSearches={recentSearches}
                                    onSearchLocationChange={location => {
                                        setUgcSearchLocation(location);
                                        ugcSearchLocationRef.current = location;
                                        if (searchTerm.length > 3) handleSearch(searchTerm);
                                    }}
                                    onUseCurrentLocation={applyBackendLocation}
                                    onSelectRecentSearch={term => {
                                        setSearchTerm(term);
                                        handleSearch(term);
                                        handleSearch.flush();
                                    }}
                                    onUgcSearchSubmit={() => {
                                        if (searchTerm.length > 3) {
                                            handleSearch(searchTerm);
                                            handleSearch.flush();
                                        }
                                    }}
                                    loading={searching}
                                    showCancelButton={!isEmpty(searchTerm)}
                                    suggestion={suggestions}
                                    uploadMessage={uploadMessage}
                                    onResume={handleOnResumeUpload}
                                    onPause={handleOnPauseUplaod}
                                    isPaused={isPaused}
                                    isFocused={searchBoxOpen}
                                    onCancelClick={handleClearSearch}
                                    onClick={handleSearchBoxOnClick}
                                    filterSelections={selectedFilterSubCategory}
                                    onTapOutsideOfLayout={collapseAll}
                                    onToggleDrawer={handleDrawerToggle}
                                    filterList={currentFilters}
                                    onChangeFilterCategory={handFilterToggle}
                                    onChangeFilterSubCategory={handleFilterSubCategorySelection}
                                    onClearFilterPressed={handleClearFilters}
                                    isSignedIn={isSignedIn}
                                    open={device.isDesktop ? true : drawerOpen}
                                    user={userProfile}
                                    onClearFilter={handleClearFilters}
                                    sidebarResize={device.isDesktop ? sidebar : undefined}>
                                    <AnimatedBox
                                        className={classes.content}
                                        style={{
                                            marginLeft: mainContentMarginLeft,
                                            maxWidth: mainContentMaxWidthExpr,
                                        }}
                                        sx={{
                                            paddingLeft: { xs: '0', sm: '0px' },
                                            paddingRight: { xs: '0', sm: '0px' },
                                            paddingTop: showFilter
                                                ? 0
                                                : isFullBleedHeroUnderHeader
                                                ? { xs: '56px', sm: '64px', lg: '72px', xl: '72px' }
                                                : { lg: '80px', sm: '50px', xs: '50px' },
                                            width: mainContentWidthExpr,
                                            maxWidth: mainContentMaxWidthExpr,
                                            minWidth: 0,
                                            overflowX: 'hidden',
                                            transition: 'none',
                                            boxSizing: 'border-box',
                                            '& > *': {
                                                maxWidth: 'min(100%, 100dvw)',
                                                minWidth: 0,
                                            },
                                        }}>
                                        <Suspense fallback={<Loading disableBG />}>
                                            {/* {showAppGuide && !pathname.includes(ROUTES.ESSETTINGS) && (
                                        <Tutorial stepsDetails={tutorialSteps} />
                                    )} */}
                                            {showAppGuide &&
                                                !showAuthModal &&
                                                !pathname.includes(ROUTES.ESSETTINGS) && (
                                                    <Tutorial
                                                        stepsDetails={{
                                                            ...tutorialSteps,
                                                            steps: tutorialSteps.steps.slice(0, -1),
                                                        }}
                                                        configField="show_app_guide"
                                                    />
                                                )}
                                            {isProjectProcessing &&
                                                !showContestUploadWait &&
                                                !pathname.includes(ROUTES.FEED) &&
                                                !device.isMobile && (
                                                    <ProgressBar
                                                        progress={progress}
                                                        onCancel={handleOnUploadCancel}
                                                        uploadMessage={uploadMessage}
                                                        onResume={handleOnResumeUpload}
                                                        onPause={handleOnPauseUplaod}
                                                        isPaused={isPaused}
                                                    />
                                                )}
                                            {showFilter && filterToRender}
                                            <DashboardWorkspaceRedirect />
                                            <Outlet />
                                        </Suspense>
                                    </AnimatedBox>
                                </EsSideBarAndHeader>
                            </Suspense>
                        </Box>
                        {isSignedIn && !buzzBridgeCampaignWorkspaceMatch && (
                            <Suspense fallback={null}>
                                <FloatingMessageButton clearAllOpenModals={handleClearAllOpenModals} />
                            </Suspense>
                        )}

                        {/* Scroll to top functionality */}
                        <EsScrollToTop />
                        {/* Auth Modal */}
                        <AuthModal />
                        {/* Creator subscription upgrade — last so it stacks above workshop/sidebar */}
                        <Suspense fallback={null}>
                            <AccountSubscriptionModal
                                open={subscriptionModalOpen}
                                onClose={handleCloseAccountSubscriptionModal}
                            />
                        </Suspense>
                        {/* Interstitial Ad Banner */}
                        {showInterstitialAd && selectedInterstitialAd && (
                            <InterstitialAdBanner
                                ad={selectedInterstitialAd}
                                onClose={handleInterstitialAdClose}
                                onPrimary={handleInterstitialAdClose}
                                onSecondary={handleInterstitialAdClose}
                            />
                        )}
                    </Box>
                )}
            </Dropzone>
        </>
    );
};

const WrappedLayout = withNetworkStatus(AppLayout);

export { WrappedLayout as AppLayout };
